import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'
import HookUtils from '@front/volcanion/utils/hooks'
import moment from 'moment'

import Component from './component'

const Container = ({ onClose, props }) => {
  const { event_id } = props || {}

  const [incident, state] = hooks.useModel('event', [event_id], {
    single: true,
    populate: [
      'driver.info',
      'vehicle.info.model.brand',
      'order.service.contract.company',
      'order.service.contract.formula',
      'order.do.commercial_formula'
    ]
  })

  const driver_info = incident?.driver?.info
  const vehicle_info = incident?.vehicle?.info
  const order = incident?.order
  const company_name = order?.service?.contract?.company?.name
  const commercial_formula = incident?.order?.service?.contract?.formula?.label_for_call_center ?? incident?.order?.do?.commercial_formula?.label_for_call_center
  const user_id = incident?.name === 'request_delete' ? incident?.produced_by : undefined

  const producer_usertype = incident?.producer_usertype
  const producedAt = incident?.producedAt
  const incident_name = incident?.name
  const driver_label = _.join(_.compact([driver_info?.user_client_id, driver_info?.first_name, driver_info?.last_name]), ' ')
  const vehicle_label = _.join(_.compact([vehicle_info?.plaque, vehicle_info?.model?.brand?.name, vehicle_info?.model?.name]), ' ')
  const requestedAt_label = !!order?.requestedAt ? moment(order?.requestedAt).format('DD/MM/YYYY [à] HH[h]mm') : undefined
  const b2b_label = _.join(_.compact([company_name, commercial_formula]), ' - ')
  const comment_label = _.find(incident?.data, ['key', 'comment'])?.value
  const [{ name: user_label }] = hooks.useCustomerInfo(user_id)

  const onSelect = useCallback(() => {
    window.open(`/incident?event_id=${event_id}`, '_blank')
    onClose?.()
  }, [event_id, onClose])

  const handleClose = useCallback((e) => {
    e.stopPropagation()
    onClose?.(e)
  }, [onClose])

  const mergedProps = {
    producer_usertype,
    producedAt,
    incident_name,
    driver_label,
    vehicle_label,
    requestedAt_label,
    comment_label,
    b2b_label,
    user_label,
    handleClose,
    onSelect
  }

  return !HookUtils.getLoadingState([state]) && (
    <Component {...mergedProps} />
  )
}

export default Container
